import PropTypes from "prop-types";
import * as React from "react";
import { addonPropType } from "../../domain";
import OrderAddonBadge, { withCancelled } from "../Addons/AddonBadge";
import PurchaseModal, { PURCHASE_TYPES } from "../PurchaseModal";
import VideoMessageRow from "./VideoMessageRow";

export default function VideoMessageAddon({
  autographPurchaseId,
  isCancelled,
  addon,
  has,
  autographPurchase,
  onPurchase,
  canPurchase,
}) {
  const purchaseProps = React.useMemo(
    () => ({
      type: PURCHASE_TYPES.ADDON_PURCHASE,
      name: addon.name,
      title: addon.title,
      description: addon.description,
      amount: addon.price.value * 100,
      autographPurchaseId,
    }),
    [addon, autographPurchaseId],
  );

  if (has) {
    return (
      <VideoMessageRow
        addon={addon}
        autographPurchase={autographPurchase}
        onChange={onPurchase}
      />
    );
  }

  return (
    <OrderAddonBadge
      title={addon.title}
      description={addon.description}
      icon={addon.icon}
      action={
        canPurchase
          ? withCancelled(isCancelled, () => (
              <PurchaseModal onPurchase={onPurchase} purchase={purchaseProps} />
            ))
          : null
      }
    />
  );
}

VideoMessageAddon.propTypes = {
  addon: addonPropType.isRequired,
  autographPurchaseId: PropTypes.number.isRequired,
  isCancelled: PropTypes.bool,
  has: PropTypes.bool,
  onPurchase: PropTypes.func,
  canPurchase: PropTypes.bool,
  autographPurchase: PropTypes.shape({
    autographPurchaseId: PropTypes.number,
    influencerName: PropTypes.string,
    videoMessageUrl: PropTypes.string,
    videoMessageProcessing: PropTypes.bool,
    signed: PropTypes.bool,
    cancelled: PropTypes.bool,
  }),
};
